<template>
    <div>
        <div :id="id" v-mdl class="item" @click="menu.toggle()">
            <span class="entry">{{ entry }}</span>
            <span class="entry-type mdl-color-text--grey-600">{{ typeLabel }}</span>
        </div>
        <ul id="blacklist-menu"
            class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--unaligned" :data-mdl-for="id"
        >
            <li class="mdl-menu__item" @click="deleteBlacklist">
                {{ $t('blacklist.delete') }}
            </li>
        </ul>
    </div>
</template>

<script>

import { Util, Api, SessionCache } from '@/utils';
import { componentHandler } from '@/lib/material.js';

export default {
    name: 'BlacklistItem',
    props: [ 'blacklistData' ],

    data () {
        return {
            menu: null,
        };
    },

    computed: {
        id () {
            return this.blacklistData.device_id;
        },

        entry () {
            return this.blacklistData.phone_number || this.blacklistData.phrase;
        },

        // PULS-1383: say which kind of entry this is, as Android's blocklist does.
        typeLabel () {
            return this.blacklistData.phone_number ? this.$t('blacklist.type_number') : this.$t('blacklist.type_phrase');
        }
    },

    mounted () {
        let menu_el = this.$el.querySelector("#blacklist-menu");
        componentHandler.upgradeElement(menu_el);

        this.menu = menu_el.MaterialMenu;
    },

    methods: {
        deleteBlacklist () {
            const options = {
                okText: this.$t('dialog.delete'),
                cancelText: this.$t('dialog.cancel'),
                animation: 'fade'
            };

            const entry = this.entry;
            this.$dialog.confirm(this.$t('blacklist.deleteconfirm', { entry }), options)
                .then(() => {
                    Util.snackbar("Deleted blacklist: " + entry);
                    Api.blacklist.delete(this.id);

                    // Remove it from the cache (and so the list) now. Refetching straight after the
                    // un-awaited delete request could still return it; the server's removed_blacklist
                    // push is a no-op once it's gone.
                    SessionCache.deleteBlacklist(this.id);
                })
                .catch(() => { }); // Cancelled
        }
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/_vars.scss";

    body.dark {
        .item:hover {
            background: #202020;
        }
    }

    .item {
        display: flex;
        height: 40px;
        line-height: 40px;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
    }

    .entry {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .entry-type {
        flex-shrink: 0;
        margin-left: 16px;
        font-size: 12px;
    }

    .item:hover {
        background: #E0E0E0;
        cursor: pointer;
    }

</style>
